export default function StorySection() {
  return (
    <section className="py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
            <span className="text-xs font-medium text-silver-300 tracking-wide">Our Story</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-8 leading-tight">Our Story</h2>
          <div className="space-y-5">
            <p className="text-base md:text-lg text-silver-300 leading-relaxed">
              StackMap Systems was born out of real operational challenges experienced in growing businesses.
            </p>
            <p className="text-base md:text-lg text-silver-300 leading-relaxed">
              As organizations expand, managing people, processes, and performance becomes increasingly complex. Many businesses rely on spreadsheets, emails, and messaging platforms to run critical functions, leading to poor visibility, inefficiencies, and limited control.
            </p>
            <p className="text-base md:text-lg text-silver-300 leading-relaxed">
              We experienced these challenges firsthand and recognized a clear gap. Businesses did not just need software, they needed structured systems that could support how they operate and scale.
            </p>
            <p className="text-base md:text-lg text-silver-300 leading-relaxed">
              StackMap began by building internal tools to solve these problems in active business environments. Over time, these tools evolved into a comprehensive suite of systems designed to bring visibility, accountability, and integration into everyday business operations.
            </p>
            <p className="text-base md:text-lg text-silver-300 leading-relaxed">
              Today, StackMap Systems provides organizations with the foundation they need to operate with clarity and confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
